import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { PLATFORMS } from "../data";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "./ui/select";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsletterForm = ({ compact = false }) => {
  const [form, setForm] = useState({ name: "", email: "", country: "", favorite_platform: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast.error("Please add your name and email.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, form);
      toast.success("Welcome to MVN NATION. You're on the list.");
      setForm({ name: "", email: "", country: "", favorite_platform: "" });
    } catch (err) {
      const msg = err?.response?.data?.detail || "Something went wrong. Please try again.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const input =
    "w-full bg-white/5 border-b border-white/20 rounded-none px-3 py-3 text-white placeholder:text-white/35 outline-none transition-colors duration-300 focus:border-amberwarm";

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="space-y-4">
      <div className={compact ? "grid sm:grid-cols-2 gap-4" : "grid md:grid-cols-2 gap-4"}>
        <input data-testid="newsletter-name" className={input} placeholder="Name" value={form.name} onChange={set("name")} />
        <input data-testid="newsletter-email" type="email" className={input} placeholder="Email" value={form.email} onChange={set("email")} />
        <input data-testid="newsletter-country" className={input} placeholder="Country" value={form.country} onChange={set("country")} />
        <Select value={form.favorite_platform} onValueChange={(v) => setForm((f) => ({ ...f, favorite_platform: v }))}>
          <SelectTrigger data-testid="newsletter-platform" className="w-full bg-white/5 border-0 border-b border-white/20 rounded-none px-3 py-6 text-white focus:ring-0 focus:border-amberwarm">
            <SelectValue placeholder="Favorite platform" />
          </SelectTrigger>
          <SelectContent className="bg-[#0a0a0a] border-white/10 text-white">
            {PLATFORMS.map((p) => (
              <SelectItem key={p} value={p} className="focus:bg-amberwarm/20 focus:text-white">{p}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <button
        type="submit"
        disabled={loading}
        data-testid="newsletter-submit"
        className="group inline-flex items-center gap-2 rounded-full bg-amberwarm px-7 py-3 text-sm font-semibold uppercase tracking-wider text-black transition-transform duration-300 hover:scale-105 disabled:opacity-60"
      >
        {loading ? "Joining..." : "Join the Movement"}
        <Send size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
      </button>
    </form>
  );
};
